import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';
import { noop } from 'lodash';
import { pad, formattedValue } from '../../../helpers/price-helper';
import Currency from '../../components/Currency';
const Price = ({
  tagName,
  className,
  getRef,
  isFormatted,
  price: {
    cents,
    value,
    converted,
    currency
  }
}) => /*#__PURE__*/React.createElement(tagName, {
  className,
  ref: getRef
}, /*#__PURE__*/React.createElement("span", {
  className: "price__ammount"
}, converted ? '~' : null, isFormatted ? formattedValue(value) : value, /*#__PURE__*/React.createElement("span", {
  className: "price__fraction"
}, !isNil(cents) && [',', pad(cents, 2)], ' ', /*#__PURE__*/React.createElement(Currency, {
  currencyCode: currency
}))));
Price.propTypes = {
  tagName: PropTypes.string,
  className: PropTypes.string,
  price: PropTypes.shape({
    cents: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    converted: PropTypes.bool,
    currency: PropTypes.string
  }).isRequired,
  getRef: PropTypes.func,
  isFormatted: PropTypes.bool
};
Price.defaultProps = {
  tagName: 'span',
  getRef: noop,
  isFormatted: false
};
export default Price;